<template>
  <div>
    <DataListStateful
      title="Запросы"
      resource="shipment-requests"
      store="shipmentRequests"
      :add-route="{ name: 'shipment-request-new' }"
      :columns="columns"
      :filter-options="filter"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "Номер",
          name: "id",
          visible: true,
          isEditLink: true,
          sortable: false,
        },
        {
          title: "Дата запроса",
          name: "date",
          visible: true,
          width: 65,
          sortable: true,
        },
        {
          title: "Статус",
          name: "state",
          visible: true,
          dataPath: "State.Title",
          sortable: true,
        },
        {
          title: "Тип поставки",
          name: "shippingType",
          dataPath: "ShippingType.Title",
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "employee",
          dataPath: "Employee.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          sortable: true,
        },
        {
          title: "Страна отправления",
          name: "sendingCountry",
          dataPath: "SendingCountry.Title",
          visible: true,
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Продавец",
          name: "factory",
          dataPath: "Factory.Title",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Регион",
          name: "region",
          dataPath: "Region.Title",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        { title: "Объем, м3", name: "volume", sortable: true },
        { title: "Вес брутто", name: "brutto", width: 50, sortable: true },
        {
          title: "Категория товара",
          name: "productCategory",
          dataPath: "ProductCategory.Title",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Город выгрузки",
          name: "unloadingCity",
          dataPath: "UnloadingCity.Title",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Дата готовности к отгрузке",
          name: "readyDate",
          width: 105,
          sortable: true,
        },
        {
          title: "Желаемая дата доставки",
          name: "wantedDate",
          width: 100,
          sortable: true,
        },
        {
          title: "Запросы из того же региона/отправителя",
          name: "sameRegionRequestIds",
          width: 150,
          sortable: false,
        },
        {
          title: "Обновления инфо",
          name: "infoUpdates",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
      ],
      filter: {
        date: {
          title: "Дата",
          type: "date",
        },
        shipmentRequestStates: {
          title: "Статус",
          type: "enum",
          resource: "shipment-request-states",
        },
        shippingTypes: {
          title: "Тип поставки",
          type: "enum",
          resource: "delivery-types",
        },
        manager: {
          title: "Менеджер",
          type: "reference",
          resource: "employees",
        },
        client: {
          title: "Клиент",
          type: "reference",
          resource: "clients",
        },
        sendingCountry: {
          title: "Страна отправления",
          type: "reference",
          resource: "countries",
        },
        factory: {
          title: "Продавец",
          type: "reference",
          resource: "factories",
        },
        region: {
          title: "Регион",
          type: "reference",
          resource: "regions",
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        productCategory: {
          title: "Категория товаров",
          type: "reference",
          resource: "product-categories",
        },
        unloadingCity: {
          title: "Город выгрузки",
          type: "reference",
          resource: "cities",
        },
        readyDate: {
          title: "Дата готовности к отгрузке",
          type: "date",
        },
        wantedDate: {
          title: "Желаемая дата доставки",
          type: "date",
        },
      },
    };
  },
};
</script>
